import React from "react";
import ReactSimpleRange from "react-simple-range";

import { formatPrice, listInstantRangeFrom, listInstantRangeTo } from "../common/common";
import CarMapLocation from "../common/carmaplocation";

import FormAddressBox from "../common/formaddress";
import { IcCarSettingGPS } from "../common/svg";

export default class CarRegisterRentingWD extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpenAddressBox: false,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	toggleLocationPicker = () => {
		this.setState({
			isShowLocationPicker: !this.state.isShowLocationPicker,
		});
	};

	onAddressLocationUpdate = (address, location) => {
		this.props.onAddressLocationUpdate(address, location);
	};

	onPriceRangeChange = (event) => {
		this.props.onPriceRangeChange(event);
	};

	toggleDelivery = () => {
		this.props.toggleDelivery();
	};

	onDiscountWeekRangeChange = (range) => {
		this.props.onDiscountWeekRangeChange(range);
	};

	onDiscountMonthRangeChange = (range) => {
		this.props.onDiscountMonthRangeChange(range);
	};

	onAddressFocus = (event) => {
		if (!this.props.address || this.props.address === "") {
			this.toggleLocationPicker();
			event.target.blur();
		}
	};

	onAddressChange = (event) => {
		this.props.onAddressChange(event);
		if (!event.target.value || event.target.value === "") {
			this.toggleLocationPicker();
			event.target.blur();
		}
	};

	toggleInstantly = () => {
		this.props.toggleInstantly();
	};

	onInstantRangeFromChange = (event) => {
		this.props.onInstantRangeFromChange(event);
	};

	onInstantRangeToChange = (event) => {
		this.props.onInstantRangeToChange(event);
	};

	toggleLimited = () => {
		this.props.toggleLimited();
	};

	onLimitedPriceRangeChange = (range) => {
		this.props.onLimitedPriceRangeChange(range);
	};

	onLimitedChange = (event) => {
		this.props.onLimitedChange(event);
	};

	onPolicyChange = (event) => {
		this.props.onPolicyChange(event);
	};

	// co tai

	onBasePriceChange = (event) => {
		this.props.onBasePriceChange(event);
	};

	onExtraKMFeeChange = (event) => {
		this.props.onExtraKMFeeChange(event);
	};

	onExtraHourFeeChange = (event) => {
		this.props.onExtraHourFeeChange(event);
	};

	onDeliveryRadiusChange = (event) => {
		this.props.onDeliveryRadiusChange(event);
	};

	onDeliveryPriceChange = (range) => {
		this.props.onDeliveryPriceChange(range);
	};

	onDeliveryRadiusFreeChange = (event) => {
		this.props.onDeliveryRadiusFreeChange(event);
	};

	showAddressBox = () => {
		this.setState({
			isOpenAddressBox: true,
		});
	};

	closeAddressBox = () => {
		this.setState({
			isOpenAddressBox: false,
		});
	};

	render() {
		//test
		const {
			basePrice,
			extraKMFee,
			extraHourFee,
			deliveryRadius,
			deliveryPrice,
			deliveryRadiusFree,
			policy,
			isDelivery,
			setting,
			cityId,
			districtId,
			wardId,
			street,
			address,
			lat,
			lng,
		} = this.props;
		const { isOpenAddressBox } = this.state;
		return (
			<div className="group form-default">
				<h6>Đơn giá thuê mặc định</h6>
				<p className="fl">
					<span className="note">
						Đơn giá áp dụng cho tất cả các ngày. Bạn có thuể tuỳ chỉnh giá khác cho các ngày đặc biệt (cuối tuần, lễ,
						tết...) trong mục quản lý xe sau khi đăng kí.
					</span>
				</p>
				<div className="space m"></div>
				<div className="space m"></div>
				<div className="space m"></div>

				{/* 1 */}

				<div className="col-left">
					<div className="form-default">
						<div className="line-form">
							<label className="label">Giá cơ bản (Lộ trình 8 tiếng/100km)</label>
							<div className="wrap-input-label d-flex">
								<div className="wrap-input">
									<input type="text" value={basePrice / 1000} onChange={this.onBasePriceChange.bind(this)} />
								</div>
								<span className="phay"> K</span>
							</div>
							<div className="space m"></div>

							<p className="pl">
								<span className="note">Giá đề xuất: {formatPrice(setting.basePriceRecommend)}</span>
							</p>
						</div>
					</div>
				</div>

				{/* 2 */}

				<div className="col-left">
					<div className="form-default">
						<div className="line-form">
							<label className="label">Phí phụ thu vượt km</label>
							<div className="wrap-input-label d-flex">
								<div className="wrap-input">
									<input type="text" value={extraKMFee / 1000} onChange={this.onExtraKMFeeChange.bind(this)} />
								</div>
								<span className="phay"> K</span>
							</div>
							<div className="space m"></div>

							<p className="pl">
								<span className="note">Giá đề xuất: {formatPrice(setting.extraKMFeeRecommend)}</span>
							</p>
						</div>
					</div>
				</div>

				{/* 3 */}

				<div className="col-left">
					<div className="form-default">
						<div className="line-form">
							<label className="label">Phí phụ thu vượt giờ</label>
							<div className="wrap-input-label d-flex">
								<div className="wrap-input">
									<input type="text" value={extraHourFee / 1000} onChange={this.onExtraHourFeeChange.bind(this)} />
								</div>
								<span className="phay"> K</span>
							</div>
							<div className="space m"></div>

							<p className="pl">
								<span className="note">Giá đề xuất: {formatPrice(setting.extraHourFeeRecommend)}</span>
							</p>
						</div>
					</div>
				</div>
				<div className="clear" />
				<div className="line" />
				<div className="space m"></div>

				<div className="form-default">
					<div className="group-inline d-flex">
						<h6>Đưa đón tận nơi</h6>
						{/* <div className="switch-on-off">
                            <input className="switch-input" id="cb-discount" type="checkbox" checked={isDelivery} onChange={this.toggleDelivery.bind(this)} />
                            <label className="switch-label" htmlFor="cb-discount"></label>
                        </div> */}
					</div>

					<div className="space m"></div>

					<div>
						<div className="col-left">
							<div className="line-form end">
								<label className="label">Đưa đón tận nơi trong vòng</label>
								<div className="range-slider">
									<ReactSimpleRange
										step={5}
										min={setting.deliveryRadiusMin}
										max={setting.deliveryRadiusMax}
										value={deliveryRadius}
										sliderSize={14}
										thumbSize={16}
										label={false}
										trackColor={"#00a550"}
										thumbColor={"#141414"}
										onChange={this.onDeliveryRadiusChange.bind(this)}
									/>
								</div>
								<span style={{ float: "right", fontSize: "14px" }}>{`${deliveryRadius}km`}</span>
								<div className="space m" />
								<p className="pl">
									<span className="note">Quãng đường đề xuất: {`${setting.deliveryRadiusRecommend}km`}</span>
								</p>
							</div>
						</div>

						<div className="col-left">
							<div className="line-form end">
								<label className="label">Miễn phí đưa đón trong vòng</label>
								<div className="range-slider">
									<ReactSimpleRange
										step={5}
										min={setting.deliveryRadiusFreeMin}
										max={setting.deliveryRadiusFreeMax}
										value={deliveryRadiusFree}
										sliderSize={14}
										thumbSize={16}
										label={false}
										trackColor={"#00a550"}
										thumbColor={"#141414"}
										onChange={this.onDeliveryRadiusFreeChange.bind(this)}
									/>
								</div>
								<span style={{ float: "right", fontSize: "14px" }}>{`${deliveryRadiusFree}km`}</span>
								<div className="space m" />
								<p className="pl">
									<span className="note">Quãng đường đề xuất: {`${setting.deliveryRadiusFreeRecommend}km`}</span>
								</p>
							</div>
						</div>

						<div className="col-left">
							<div className="line-form end">
								<label className="label">Phí đưa đón</label>
								<div className="range-slider">
									<ReactSimpleRange
										step={1000}
										min={setting.deliveryPriceMin}
										max={setting.deliveryPriceMax}
										value={deliveryPrice}
										sliderSize={14}
										thumbSize={16}
										label={false}
										trackColor={"#00a550"}
										thumbColor={"#141414"}
										onChange={this.onDeliveryPriceChange.bind(this)}
									/>
								</div>
								<span style={{ float: "right", fontSize: "14px" }}>{`${
									deliveryPrice > 0 ? `${formatPrice(deliveryPrice)}` : "Miễn phí"
								}`}</span>
								<div className="space m" />
								<p className="pl">
									<span className="note">Phí đề xuất: {formatPrice(setting.deliveryPriceRecommend)}</span>
								</p>
							</div>
						</div>

						<div className="space m clear" />
						<div className="line" />
					</div>
				</div>

				{/* phan giua */}
				<div className="form-default">
					{/* dat xe nhanh */}
					<div className="group-inline d-flex">
						<h6>Đặt xe nhanh</h6>
						{/* cong tac on off */}
						<div className="switch-on-off">
							<input
								className="switch-input"
								id="cb-instantly"
								type="checkbox"
								checked={this.props.isInstantly}
								onChange={this.toggleInstantly.bind(this)}
							/>
							<label className="switch-label" htmlFor="cb-instantly" />
						</div>
					</div>

					<div className="space m" />
					<span className="note marginBottom-xs" style={{ color: "red" }}>
						Bật tính năng cho phép khách hàng đặt xe ngay lập tức không cần chủ xe phê duyệt. (Phù hợp với chủ xe không
						thường xuyên online hoặc kiểm tra điện thoại)
					</span>
					{this.props.isInstantly && (
						<div className="col-left">
							<div className="line-form">
								<label className="label">Giới hạn từ</label>
								<span className="wrap-select">
									<select onChange={this.onInstantRangeFromChange.bind(this)} value={this.props.instantRangeFrom}>
										{listInstantRangeFrom &&
											listInstantRangeFrom.map((option) => (
												<option key={option.key} value={option.key}>
													{option.value}
												</option>
											))}
									</select>
								</span>
							</div>
						</div>
					)}

					{this.props.isInstantly && (
						<div className="col-right">
							<div className="line-form">
								<label className="label">Cho đến</label>
								<span className="wrap-select">
									<select onChange={this.onInstantRangeToChange.bind(this)} value={this.props.instantRangeTo}>
										{listInstantRangeTo &&
											listInstantRangeTo.map((option) => (
												<option key={option.key} value={option.key}>
													{option.value}
												</option>
											))}
									</select>
								</span>
							</div>
						</div>
					)}
					<div className="space m" />

					<h6>Địa chỉ xe</h6>
					<div className="line-form">
						<FormAddressBox
							show={isOpenAddressBox}
							close={this.closeAddressBox}
							cityId={cityId}
							wardId={wardId}
							districtId={districtId}
							street={street}
							address={address}
							onUpdate={this.props.onAddressLocationUpdate}
							locAddress={{ lat, lng }}
						/>
						<div className="wrap-input has-ico-search">
							<div className="wrap-svg pointer" onClick={this.showAddressBox}>
								<IcCarSettingGPS />
							</div>
							<input
								type="text"
								value={this.props.address}
								disabled={true}
								placeholder={"Địa chỉ mặc định để giao nhận xe."}
							/>
						</div>
					</div>
					{this.props.address !== "" && this.props.lat !== 0 && this.props.lng !== 0 && (
						<CarMapLocation address={this.props.address} location={{ lat: this.props.lat, lng: this.props.lng }} />
					)}
					<div className="space m clear" />

					<div className="space m clear" />
					<div className="line" />
				</div>

				{/* final */}
				{/* dieu khoan */}
				<div className="space m" />
				<h6>Điều khoản thuê xe</h6>
				<p>
					<span className="note">Ghi rõ các yêu cầu để khách có thể thuê xe.</span>
				</p>
				<div className="line-form end custom-textarea">
					<textarea
						className="textarea"
						onChange={this.onPolicyChange.bind(this)}
						placeholder={`1. Không hút thuốc trên xe hoặc mang các thực phẩm có mùi
2. Để đảm bảo thời gian đón khách đúng giờ & tránh tắc đường, tài xế chỉ đón khách tại điểm đã đặt xe hoặc điểm thay thế (Vui lòng báo trước cho tài xế trong trường hợp có thay đổi địa điểm đón khách)
3. Trong trường hợp khách thuê thay đổi lộ trình chuyến đi, vui lòng báo trước với tài xế để chuẩn bị và chăm sóc tốt hơn
Chúc Quý Khách chuyến đi vui vẻ`}
						value={policy}
					/>
				</div>
				<div className="space m" />
			</div>
		);
	}
}
